export enum InfractionRuleType {
    Compare_Dates = 0,
    Text_Search_Match = 1,
    Column_Text_Length = 2
}